import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ChartLoader from '../../Loaders/ChartLoader';
import CustomLineChart from '../../Custom/CustomLineChart';
import axios from '../../../utils/axiosClient';

class ActivePowerVsTime extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      reinitialize: true,
      options: {},
    };
  }

  componentDidMount() {
    const { deviceId } = this.props;
    this.bindData(deviceId, 1); // no. of months
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.deviceId, nextProps.deviceId)) {
      this.setState({ reinitialize: true }, () =>
        this.bindData(nextProps.deviceId, 1)
      );
    }
  }

  bindData(deviceId, numberOfMonths) {
    axios
      .post('Report/ActivePWRVsTime', { deviceId, sze: numberOfMonths })
      .then(({ data }) => {
        if (data.statusCode === 200) {
          this.drawChart(
            data.result.realPowervsTimeData,
            data.result.units.PowerUnit,
            deviceId,
            numberOfMonths
          );
        } else {
          this.drawChart([], '', deviceId, numberOfMonths);
        }
      })
      .catch(() => {
        this.drawChart([], '', deviceId, numberOfMonths);
      });
  }

  async drawChart(data, units, deviceId, numberOfMonths) {
    const realPower1 = [];
    const realPower2 = [];
    const realPower3 = [];

    if (data.length > 0) {
      data.forEach(async (element) => {
        const tmstmp = Date.parse(element.reportedTime.replace('T', ' '));
        realPower1.push([tmstmp, parseFloat(element.realPower1)]);
        realPower2.push([tmstmp, parseFloat(element.realPower2)]);
        realPower3.push([tmstmp, parseFloat(element.realPower3)]);
      });
    }
    const self = this;
    const obj = {
      title: 'Active Power Profile',
      unit: units,
      selected: numberOfMonths === 1 ? 0 : 3,
      params: {
        deviceId,
        numberOfMonths,
      },
      series: [
        {
          name: 'ActivePower-1',
          color: '#da532c',
          data: realPower1,
        },
        {
          name: 'ActivePower-2',
          color: '#FFFF00',
          data: realPower2,
        },
        {
          name: 'ActivePower-3',
          color: '#2d89ef',
          data: realPower3,
        },
      ],
      evnt: () =>
        self.setState({ reinitialize: true }, () => self.bindData(deviceId, 6)),
    };
    this.setState({
      options: obj,
      reinitialize: false,
    });
  }

  render() {
    const { options } = this.state;
    return (
      <div>
        {!this.state.reinitialize ? (
          <CustomLineChart options={options} />
        ) : (
          <ChartLoader height="150" width="600" />
        )}
      </div>
    );
  }
}

ActivePowerVsTime.propTypes = {
  deviceId: PropTypes.number.isRequired,
};

export default ActivePowerVsTime;
